var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:_vm.getConfirmClass,attrs:{"color":_vm.getConfirmColor,"label":""}},[_vm._v(" "+_vm._s(_vm.isConfirm ? _vm.textYes : _vm.textNo)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }